import { CursorPaginationParametersRequest } from '@/modules/common/types/pagination-types';

import { ProjectStatusDTO, ProjectStatusRequest } from '../project-status.dto';

/**
 * All active (non-archived) project statuses.
 * Use this when loading projects for selection (e.g. the time-entry project
 * dropdown) to exclude archived projects from results.
 */
export const NON_ARCHIVED_PROJECT_STATUSES: ProjectStatusRequest[] = [
  ProjectStatusDTO.TENTATIVE,
  ProjectStatusDTO.ACTIVE,
];

/**
 * Filter criteria for finding short projects.
 */
export interface FindShortProjectsFilterRequest {
  /** Search string to filter projects by name */
  searchString?: string;

  /** Filter by project status */
  status?: ProjectStatusRequest[];
}

/**
 * Request DTO for finding short projects with pagination and filters.
 */
export interface FindShortProjectsRequest {
  /** Pagination parameters */
  pagination?: CursorPaginationParametersRequest;

  /** Filter criteria for finding short projects */
  filter?: FindShortProjectsFilterRequest;
}
